import type { NextRequest } from "next/server";
import { env } from "../env";

export const getHostFromRequest = (request: NextRequest): string => {
	const hostHeader = request.headers.get("x-forwarded-host")?.split(",")[0]?.trim() || request.headers.get("host");
	const hostProtocol = request.headers.get("x-forwarded-proto") || request.nextUrl.protocol;

	if (hostHeader?.includes(env.NEXT_PUBLIC_APP_DOMAIN)) {
		return new URL(`${hostProtocol}://${hostHeader}`).origin;
	}
	return new URL(request.nextUrl.origin).origin;
};

export const getHost = (subdomain?: string) => {
	const isUsingHttps = env.NEXT_PUBLIC_API_URL?.startsWith("https://");
	const protocol = isUsingHttps ? "https" : "http";
	const isTestEnv = env.NEXT_PUBLIC_ENVIRO === "automatedtest";
	if (subdomain && !isTestEnv) {
		return new URL(`${protocol}://${subdomain}.${env.NEXT_PUBLIC_APP_DOMAIN}`).origin;
	}
	return new URL(`${protocol}://${env.NEXT_PUBLIC_APP_DOMAIN}`).origin;
};
